import {
    createContext, FC, useState, Dispatch, SetStateAction, ReactNode
} from 'react';
import Constants, { APP_ROUTES } from '../../Utils/Constants';
import { IFormStep } from '../../Utils/Constants/FormSteps';
import { IKycDetails } from '../../Service/IUserService';

interface IStepContext {
    currentFormStep: IFormStep
    setCurrentFormStep: Dispatch<SetStateAction<IFormStep>>;
    whitelistedUser: boolean;
    setWhitelistedUser: Dispatch<SetStateAction<boolean>>;
    documentType: string | null;
    setDocumentType: Dispatch<SetStateAction<string | null>>;
    documentDescription: string;
    setDocumentDescription: Dispatch<SetStateAction<string>>;
    premiumUser: boolean;
    setPremiumUser: React.Dispatch<React.SetStateAction<boolean>>;
    existingCustomer: boolean;
    validStetus: boolean;
    setValidStetus: Dispatch<SetStateAction<boolean>>;
    setOldCustomerExists: React.Dispatch<React.SetStateAction<boolean>>;
    kycDetails?: IKycDetails;
    setKycDetails: Dispatch<SetStateAction<IKycDetails | undefined>>;
    captureBackSide: boolean;
    setCaptureBackSide: Dispatch<SetStateAction<boolean>>;

    othersType: {
        id: string;
        key: string;
        description: string;
        label: string;
    } | null;
    setOthersType: Dispatch<SetStateAction<{
        id: string;
        key: string;
        description: string;
        label: string;
    } | null>
    >;
}

const initialState: IStepContext = {
    currentFormStep: location.pathname === APP_ROUTES.TERMS_AND_CONDITIONS
        ? Constants.FORM_STEPS.TERMS_AND_CONDITIONS
        : Constants.FORM_STEPS.ONBOARDING,
    setCurrentFormStep: () => {},
    whitelistedUser: false, // Default to false, change based on your logic
    setWhitelistedUser: () => {},
    documentType: null,
    setDocumentType: () => {},
    documentDescription: '',
    setDocumentDescription: () => {},
    premiumUser: false,
    setPremiumUser: () => {},
    validStetus: false,
    setValidStetus: () => {},
    existingCustomer: false,
    setOldCustomerExists: () => {},
    kycDetails: undefined,
    setKycDetails: () => {},
    othersType: null,
    setOthersType: () => {},
    captureBackSide: false,
    setCaptureBackSide: () => {}
};

const StepContext = createContext<IStepContext>(initialState);

export const StepContextProvider: FC< { children: ReactNode }> = ({ children }) => {
    const [currentFormStep,
        setCurrentFormStep] = useState<IFormStep>(initialState.currentFormStep);
    const [whitelistedUser, setWhitelistedUser] = useState<boolean>(initialState.whitelistedUser);
    const [premiumUser, setPremiumUser] = useState<boolean>(false);
    const [validStetus, setValidStetus] = useState<boolean>(false);
    const [existingCustomer, setOldCustomerExists] = useState<boolean>(false);
    const [documentType, _setDocumentType] = useState<string | null>(null);
    const [captureBackSide, setCaptureBackSide] = useState<boolean>(false);
    const [documentDescription, setDocumentDescription] = useState<string>('');
    const [kycDetails, setKycDetails] = useState<IKycDetails | undefined>(undefined);
    const [othersType, setOthersType] = useState<{
        id: string;
        key: string;
        description: string;
        label: string;
    } | null>(null);

    const setDocumentType = (value: SetStateAction<string | null>) => {
        _setDocumentType(value);
    };
    return (
        <StepContext.Provider
            value={{
                currentFormStep,
                setCurrentFormStep,
                whitelistedUser,
                setWhitelistedUser,
                documentType,
                setDocumentType,
                documentDescription,
                setDocumentDescription,
                premiumUser,
                setPremiumUser,
                validStetus,
                setValidStetus,
                existingCustomer,
                setOldCustomerExists,
                kycDetails,
                setKycDetails,
                othersType,
                setOthersType,
                captureBackSide,
                setCaptureBackSide
            }}
        >
            {children}
        </StepContext.Provider>
    );
};

export default StepContext;
